import path from "path";
import { imagesFullPath, imagesThumbPath } from "./constants_web";
import { WebOpenHandle, WebSaveHandle } from "./filehandles_web";
import { LanguageKeys, OpenFileHandle } from "./measure_shared/CommonTypes";


export const saveBlob = (() => {
  let a = document.createElement('a');
  a.style.display = 'none';
  document.body.appendChild(a);
  return async (blob: Blob, suggestedName: string) => {
    var url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = suggestedName;
    a.click();
    window.URL.revokeObjectURL(url);
  };
})();


export const openLink = (() => {
  let a = document.createElement('a');
  a.style.display = 'none';
  document.body.appendChild(a);
  return (link: string, newTab: boolean = true) => {
    a.href = link;
    a.target = newTab ? '_blank' : '';
    a.click();
  };
})();

export const isInternal = (src: string) => src.startsWith('structem-measure-image');

export const getSrcString = (src: string) => {
  if (isInternal(src))
    return path.join(imagesFullPath, src);
  return src;
};

export const getThumbString = (src: string) => {
  if (isInternal(src))
    return Promise.resolve(path.join(imagesThumbPath, src));
  return Promise.resolve(src);
};

export const openDialog = (title: string, validExtensions: string[], allowMultiple: boolean, lang: LanguageKeys): Promise<WebOpenHandle[]> => {
  return new Promise<WebOpenHandle[]>((resolve, reject) => {
    let fakeInput = document.createElement('input');
    fakeInput.type = 'file';
    fakeInput.accept = validExtensions.join(', ');
    fakeInput.multiple = allowMultiple;
    fakeInput.addEventListener('change', () => {
      if (fakeInput.files)
        resolve([...fakeInput.files].map(f => new WebOpenHandle(f)));
      else
        resolve([]);
    }, { once: true });
    fakeInput.click();
  });
};

export const saveDialog = (title: string, suggestedName: string, lang: LanguageKeys): Promise<WebSaveHandle | undefined> => {
  return Promise.resolve(new WebSaveHandle(suggestedName));
};

export const blobToSrc = (blob: Blob, name: string) => {
  return Promise.resolve({ src: window.URL.createObjectURL(blob), name });
};

export const fileToSrc = (file: OpenFileHandle) => {
  const handle = file as WebOpenHandle;
  return blobToSrc(handle.file, handle.file.name);
}